import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-24" }, "Remessa de Boletos")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Imprimir", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Baixar Arquivo", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col ant-col-xs-2 ant-col-xl-2" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "ant-col ant-col-xs-3 ant-col-xl-3" }
const _hoisted_10 = { class: "ant-col ant-col-xs-2 ant-col-xl-2" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "ant-col ant-col-xs-2 ant-col-xl-2" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "ant-row" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { key: 3 }
const _hoisted_22 = { key: 4 }
const _hoisted_23 = {
  key: 5,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_24 = { class: "ant-row" }
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 2 }
const _hoisted_29 = { key: 3 }
const _hoisted_30 = { key: 4 }
const _hoisted_31 = {
  key: 5,
  class: "ss-table-apresentacao-mobile"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_card = _resolveComponent("card")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: 1000,
    centered: "",
    "wrap-class-name": "scroll-modal ss-modal-financeiro"
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-secondary",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.imprimir && _ctx.imprimir(...args)))
        }, _hoisted_3),
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.baixarArquivo && _ctx.baixarArquivo(...args)))
        }, _hoisted_5)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_card, { titulo: "Dados da Remessa" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_a_form_item, {
                label: "Sequência",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("input", {
                    type: "text",
                    class: "ant-input",
                    style: {"text-align":"right"},
                    value: _ctx.state.remessa.sequencia,
                    disabled: "true"
                  }, null, 8, _hoisted_8)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_a_form_item, {
                label: "Data de Geração",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_selecionar_data, {
                    "data-selecionada": _ctx.state.remessa.dataGeracao,
                    disabled: true
                  }, null, 8, ["data-selecionada"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_a_form_item, {
                label: "Layout",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("input", {
                    type: "text",
                    class: "ant-input",
                    value: _ctx.state.remessa.layout === 1 ? 'CNAB240' : 'CNAB400',
                    disabled: "true"
                  }, null, 8, _hoisted_11)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_a_form_item, {
                label: "Versão",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("input", {
                    type: "text",
                    class: "ant-input",
                    style: {"text-align":"right"},
                    value: _ctx.state.remessa.versaoLayout,
                    disabled: "true"
                  }, null, 8, _hoisted_13)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_a_form_item, {
                label: "Código de Transmissão",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("input", {
                    type: "text",
                    class: "ant-input",
                    value: _ctx.state.remessa.codigoTransmissao,
                    disabled: "true"
                  }, null, 8, _hoisted_15)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_card, { titulo: "Títulos da Remessa" }, {
        default: _withCtx(() => [
          ((_ctx.modalBase.computedVisivel))
            ? (_openBlock(), _createBlock(_component_a_skeleton, {
                key: 0,
                loading: _ctx.telaBase.carregando,
                paragraph: { rows: 15 }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form, { layout: "vertical" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_a_table, {
                            columns: _ctx.state.colunasTitulos.filter(item => item.visible),
                            "data-source": _ctx.state.titulos,
                            rowKey: "numeroTitulo",
                            pagination: false,
                            size: "small",
                            rowClassName: "ss-table-campos"
                          }, {
                            emptyText: _withCtx(() => [
                              _createVNode(_component_mensagem_sem_dados, { mensagem: "Remessa vazia" })
                            ]),
                            bodyCell: _withCtx(({ column, record }) => [
                              (column.key === 'NumeroTitulo')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(record.numeroTitulo), 1))
                                : _createCommentVNode("", true),
                              (column.key === 'NomePessoa')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(record.nomePessoa), 1))
                                : (column.key === 'Vencimento')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.dataVencimento)), 1))
                                  : (column.key === 'Saldo')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.saldo, 2, true)), 1))
                                    : (column.key === 'Categoria')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(record.nomePlanoContaCategoria), 1))
                                      : (column.key === 'DetalhePagamento')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                            _createElementVNode("span", null, "Título: " + _toDisplayString(record.numeroTitulo), 1),
                                            _createElementVNode("span", null, "Pessoa " + _toDisplayString(record.nomePessoa), 1),
                                            _createElementVNode("span", null, "Categoria " + _toDisplayString(record.nomePlanoContaCategoria), 1),
                                            _createElementVNode("span", null, "Vencimento: " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.data)), 1),
                                            _createElementVNode("span", null, "Valor: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.saldo, 2, true)), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["columns", "data-source"])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_card, { titulo: "Remessas Anteriores" }, {
        default: _withCtx(() => [
          ((_ctx.modalBase.computedVisivel))
            ? (_openBlock(), _createBlock(_component_a_skeleton, {
                key: 0,
                loading: _ctx.telaBase.carregando,
                paragraph: { rows: 15 }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form, { layout: "vertical" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createVNode(_component_a_table, {
                            columns: _ctx.state.colunasRemessas.filter(item => item.visible),
                            "data-source": _ctx.state.remessa.remessasAnteriores,
                            rowKey: "sequencia",
                            pagination: false,
                            size: "small",
                            rowClassName: "ss-table-campos"
                          }, {
                            emptyText: _withCtx(() => [
                              _createVNode(_component_mensagem_sem_dados, { mensagem: "Sem remessa anterior" })
                            ]),
                            bodyCell: _withCtx(({ column, record }) => [
                              (column.key === 'Sequencia')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(record.sequencia), 1))
                                : _createCommentVNode("", true),
                              (column.key === 'Layout')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(record.layout === 1 ? 'CNAB240' : 'CNAB400'), 1))
                                : _createCommentVNode("", true),
                              (column.key === 'VersaoLayout')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(record.versaoLayout), 1))
                                : _createCommentVNode("", true),
                              (column.key === 'Arquivo')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(record.arquivo), 1))
                                : (column.key === 'DataGeracao')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.dataGeracao)), 1))
                                  : (column.key === 'Detalhe')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                        _createElementVNode("span", null, "Sequência: " + _toDisplayString(record.sequencia), 1),
                                        _createElementVNode("span", null, "Layout " + _toDisplayString(record.layout === 1 ? 'CNAB240' : 'CNAB400'), 1),
                                        _createElementVNode("span", null, "Versão " + _toDisplayString(record.versaoLayout), 1),
                                        _createElementVNode("span", null, "Data da Geração: " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.dataGeracao)), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["columns", "data-source"])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_preview_pdf, {
        arquivos: _ctx.state.arquivosPdf
      }, null, 8, ["arquivos"])
    ]),
    _: 1
  }, 8, ["visible"]))
}